export default __webpack_public_path__ + "images/ba7e86fcbc339a615236a2753e355de7.png";